import {VImage} from "./vet-clinic.model";

/**
 * Model globalnych ustawień wizualnych i opisowych programu Pakietów Opieki (Abonamentów)
 * przypisanych do konkretnego klienta.
 */
export class ClientUserCarePlanSettings {

  /** Globalnie unikalny identyfikator ustawień. */
  public uuid: string;

  /** Identyfikator administratora, który po raz pierwszy skonfigurował program abonamentowy. */
  public authorUUID: string;

  /** Identyfikator użytkownika, który jako ostatni wprowadzał zmiany w ustawieniach. */
  public editorUUID: string;

  /** Identyfikator klienta B2B, do którego należą te ustawienia.
   */
  public vClientUUID: string;


  /** Główna nazwa programu abonamentowego dla tej kliniki.
   */
  public name: string;

  /** Rozbudowany opis programu, zachęcający pacjentów do dołączenia.
   * Często tłumaczy ogólne zasady działania abonamentu i jego korzyści.
   */
  public description: string;


  /** Standardowe zdjęcie/grafika promująca program abonamentowy.
   */
  public photo: VImage;

  /** Identyfikator zapisanego pliku miniatury. */
  public photoImageUUID: string;

  /** Duże zdjęcie w tle.
   */
  public largePhoto: VImage;

  /** Identyfikator zapisanego pliku dużego zdjęcia. */
  public largePhotoImageUUID: string;

}
